<template>
  <div class="login-bg">
    <v-img
      class="login-trysilhusLogo"
      width="180"
      src="https://thg.blob.core.windows.net/public-images/Trysilhus_logo_hvit.png"
    ></v-img>

    <span v-if="isKiosk && !$vuetify.breakpoint.xs">
      <div v-if="projects.length > 0" class="qr1">
        <QrCode :projectId="projects[0].id" :projectsName="projects[0].name" />
      </div>
      <div v-if="projects.length > 1" class="qr2">
        <QrCode :projectId="projects[1].id" :projectsName="projects[1].name" />
      </div>
      <div v-if="projects.length > 2" class="qr3">
        <QrCode :projectId="projects[2].id" :projectsName="projects[2].name" />
      </div>
      <div v-if="projects.length > 3" class="qr4">
        <QrCode :projectId="projects[3].id" :projectsName="projects[3].name" />
      </div>
    </span>

    <v-card
      class="mx-auto"
      color="#FFFFFF"
      elevation="6"
      max-width="320"
      min-width="320"
      min-height="300"
    >
      <div class="login-content pa-12 text-center">
        <v-img
          class="mx-auto"
          width="80"
          height="80"
          src="https://thg.blob.core.windows.net/public-images/bt_icon.svg"
        ></v-img>
        <h3 class="mt-1 mb-5 album--text">Bygg Trysilhus {{ env }}</h3>

        <div class="text-center">
          <v-btn
            depressed
            small
            style="width: 100%"
            color="album"
            @click="login"
            dark
          >
            Logg inn
          </v-btn>

          <div class="my-2">
            <!-- <a class="caption info--text" @click="openPDF">
              <v-icon small color="info">mdi-information</v-icon>
              Slik logger du deg på
            </a> -->
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import QrCode from "@/components/shared/QrCode.vue";

export default {
  name: "login",
  data() {
    return {
      projects: [],
    };
  },
  mounted() {
    this.projects = JSON.parse(localStorage.getItem("kioskProjects"));
  },
  methods: {
    // Log the user in
    async login() {
      if (this.$router.history._startLocation !== "/") {
        await localStorage.setItem(
          "btLogin",
          this.$router.history._startLocation
        );
        this.$router.push(this.$router.history._startLocation);
      } else {
        this.$router.push({ name: "Dashboard" });
      }
    },
    openPDF() {
      window.open(
        "https://thg.blob.core.windows.net/public-assets/Bygg_Trysilhus-Brukerveiledning.pdf"
      );
    },
  },
  computed: {
    ...mapGetters({
      isKiosk: "shared/isKiosk",
    }),
    env() {
      console.info("env", process.env.VUE_APP_ENVIRONMENT);
      if (
        process.env.VUE_APP_ENVIRONMENT === "Dev" ||
        process.env.VUE_APP_ENVIRONMENT === "Test"
      ) {
        return process.env.VUE_APP_ENVIRONMENT;
      }

      return "";
    },
  },
  components: {
    QrCode,
  },
};
</script>
<style lang="scss">
.login-bg {
  background: url("https://thg.blob.core.windows.net/public-images/login_bg.jpg")
    no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  top: 0;
  left: 0;
  position: fixed;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  .login-trysilhusLogo {
    position: absolute;
    top: 3%;
    left: 2%;
  }
  @media (max-width: 768px) {
    .login-trysilhusLogo {
      left: 50%;
      top: 91%;
      transform: translate(-50%, -50%);
    }
  }
}
.qr1 {
  position: absolute;
  top: 15%;
  left: 10%;
}
.qr2 {
  position: absolute;
  top: 15%;
  right: 10%;
}
.qr3 {
  position: absolute;
  bottom: 15%;
  left: 10%;
}
.qr4 {
  position: absolute;
  bottom: 15%;
  right: 10%;
}
</style>
